import {FC} from 'react';
import HeaderBasic from 'components/Headers/Basic';
import {useBackend} from 'state/backend';
import {Backend} from 'types/api';
import MagicLinkFAQ from '../components/MagicLinkFAQ';
import MagicLinkForm from '../components/MagicLinkForm';
import PortalNotification, {
    MessageKind,
} from '../components/PortalNotification';
import PortalPageLayout from '../components/PortalPageLayout';

export type PortalLoginBackend = Backend<{
    email: string;
    message?: MessageKind;
    next: string;
    partnerName?: string;
    remember: boolean;
    sessionMinutes?: number;
}>;

const PortalLogin: FC = () => {
    const {data} = useBackend<PortalLoginBackend>();

    return (
        <PortalPageLayout isResponsive={true}>
            <HeaderBasic
                className="px-8 pb-2"
                dropdownLocaleSize="xs"
                showSignIn={false}
            />
            <div className="flex flex-col gap-y-4 px-8 w-fit">
                <PortalNotification kind={data.message} />
                <MagicLinkForm
                    defaultEmail={data.email}
                    hasRemember={data.remember}
                    next={data.next}
                    partnerName={data.partnerName}
                    sessionMinutes={data.sessionMinutes}
                />
                <MagicLinkFAQ />
            </div>
        </PortalPageLayout>
    );
};

export default PortalLogin;
